import React from 'react';
import AuthService from './authService.js';
import TpDataExportExcludedItem from '../Domain/TpDataExportExcludedItem.js';
import SearchParams from '../Elements/SearchParams';
import TpDataExportExcludedItemSearchParams from '../Contents/ThirdParty/TpDataExportExcludedItem/TpDataExportExcludedItemSearchParams';

export default class TpDataExportExcludedItemService extends React.Component {
  static GetAllItemBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, TpDataExportExcludedItemSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    const url = `/api/TpDataExportExcludedItem/GetItems/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunction(url);
  }

  static ConvertDBItems(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new TpDataExportExcludedItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }

  static IgnoreItem(id) {
    const objToSend = { id, info: 'Ignored' };
    const url = `/api/TpDataExportExcludedItem/SetItemStatus/`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPut(url, objToSend);
  }

  static ActivateItem(id) {
    const objToSend = { id, info: 'Active' };
    const url = `/api/TpDataExportExcludedItem/SetItemStatus/`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPut(url, objToSend);
  }

  static BulkStatusChange(selectedIds, newStatus) {
    const objToSend = { ids: selectedIds, info: newStatus };
    const url = `/api/TpDataExportExcludedItem/BulkStatusChange/`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPut(url, objToSend);
  }
}
